<template>
    <div>
        <v-dialog v-model="openDialog" persistent width="500px">
            <v-card style="overflow: hidden">
                <v-card-title>
                    {{ $t('layout.change_theme') }}
                    <v-spacer></v-spacer>
                    <v-btn icon @click="$emit('close')">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-row class="pa-5">
                    <v-col cols="12">
                        <v-text-field
                            v-model="primaryColor"
                            outlined
                            dense
                            :label="$t('layout.primary_color')"
                        >
                            <template v-slot:append-outer>
                                <v-icon :color="primaryColor"
                                    >mdi-square</v-icon
                                >
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                            v-model="secondaryColor"
                            outlined
                            dense
                            :label="$t('layout.secondary_color')"
                        >
                            <template v-slot:append-outer>
                                <v-icon :color="secondaryColor"
                                    >mdi-square</v-icon
                                >
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col
                        v-if="error"
                        cols="12"
                        class="my-n2 d-flex justify-end align-center"
                    >
                        <p class="red--text">
                            {{ $t('messages.save.error_alt', {item: $t('layout.color_configuration') }) }}
                        </p>
                    </v-col>
                    <v-col cols="12" class="d-flex justify-end align-center">
                        <v-btn
                            color="primary"
                            :loading="loading"
                            class="my-n2"
                            @click="saveColors(primaryColor, secondaryColor)"
                            >
                            {{ $t('common.save') }}
                            </v-btn
                        >
                    </v-col>
                </v-row>
            </v-card>
        </v-dialog>
        <v-dialog v-model="success" width="600px">
            <v-card color="primary" class="text-center">
                <v-card-title class="white--text">
                   {{ $t('messages.save.success_alt', { item: $t('layout.color_configuration') }) }}
                </v-card-title>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn text class="white--text" @click="success = false">
                        {{ $t('common.close') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
    name: 'ColorDialog',
    props: {
        openDialog: { type: Boolean, default: false },
    },
    computed: {
        ...mapState({
            user: (state) => state.user.data,
            attributes: (state) => state.project.attributes
        }),
    },
    data() {
        return {
            primaryColor: null,
            secondaryColor: null,
            loading: false,
            error: false,
            success: false,
        }
    },
    methods: {
        ...mapActions({
            updateAttributes: 'project/updateAttributes',
            setProject: 'project/setProject'
        }),
        isValidHexColor(value) {
            const hexRegex = /^#([0-9A-Fa-f]{3}){1,2}$/i
            return hexRegex.test(value)
        },
        async saveColors(primary, secondary) {
            try {
                this.error = false
                this.loading = true
                await this.updateAttributes({
                    name: "colors",
                    data: { primary, secondary },
                });
                this.$vuetify.theme.themes.light.primary = primary
                this.$vuetify.theme.themes.light.secondary = secondary
                this.primaryColor = primary
                this.secondaryColor = secondary
                this.$emit('close')
                this.loading = false
                this.success = true
            } catch (error) {
                this.error = true
                this.loading = false
                this.$vuetify.theme.themes.light.primary = this.primaryColor
                this.$vuetify.theme.themes.light.secondary = this.secondaryColor
            }
        },
    },
    mounted() {
        const colors = JSON.parse(localStorage.getItem('colors'))
        if(!colors) return
        this.primaryColor = colors.primary
        this.secondaryColor = colors.secondary
    },
    watch: {
        'attributes.colors': {
            handler(){
                const PRIMARY_COLOR = '#06D676'
                const SECONDARY_COLOR = '#023243'

                const colors = this.attributes.hasOwnProperty('colors') 
                                    ? this.attributes.colors
                                    :  {
                                            primary: PRIMARY_COLOR,
                                            secondary: SECONDARY_COLOR
                                       }

                localStorage.setItem('colors', JSON.stringify(colors))
                this.$vuetify.theme.themes.light.primary = colors.primary
                this.$vuetify.theme.themes.light.secondary = colors.secondary
                this.primaryColor = colors.primary
                this.secondaryColor = colors.secondary
            },
            deep: true
        }
    }
}
</script>

<style scoped></style>
